// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-select.mobile-select {
  border: 1px solid #666;
}
ion-select.mobile-select .item-cover {
  width: 0;
  height: 0;
}

.center-item-options {
  display: flex !important;
  justify-content: center !important;
}

ion-select.select {
  margin: auto;
}

ion-button {
  text-wrap: nowrap;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/cool-off/cool-off.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;AAAE;EACI,QAAA;EACA,SAAA;AAEN;;AACE;EACA,wBAAA;EACA,kCAAA;AAEF;;AAAA;EACE,YAAA;AAGF;;AAAA;EACE,iBAAA;AAGF","sourcesContent":["ion-select.mobile-select {\r\n  border: 1px solid #666;\r\n  .item-cover {\r\n      width: 0;\r\n      height: 0;\r\n  }\r\n}\r\n  .center-item-options {\r\n  display: flex !important; \r\n  justify-content: center !important;\r\n}\r\nion-select.select {\r\n  margin: auto;\r\n}\r\n\r\nion-button {\r\n  text-wrap: nowrap;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
